import React from 'react';
import MyTabs from '@/components/Tabs';
import { TabsContent } from '@/components/job-title';

const BASE_TAP_MARGIN = 48;
const TAB_BOTTOM_MARGIN = 14;

const TabNav = (props: {
  generalEl: React.RefObject<any>;
  isLogin: boolean;
  tabsClassName?: string;
}) => {
  const {
    generalEl,
    isLogin,
    tabsClassName = '!max-w-8xl !m-auto !py-0 !px-[10%]',
  } = props;

  return (
    <MyTabs
      className="!mb-3.5 !hidden [&_.MuiTabs-indicator]:!bg-black data-[active=true]:bg-white tablet:!block"
      tabsClassName={tabsClassName}
      generalEl={generalEl}
      tabsContent={TabsContent}
      tabMargin={BASE_TAP_MARGIN}
      tabsBottomMargin={TAB_BOTTOM_MARGIN}
      tabClassName="!mr-6 !py-4 !px-0 !font-medium !min-w-[unset] !text-denim data-[active=true]:!text-black/85"
      dataEleGroup="tab_job-title"
      stickyTopClassName={isLogin ? 'top-0' : 'top-16'}
    />
  );
};

export default TabNav;
